import { render } from "./FormFieldsConfigModal.vue?vue&type=template&id=059c0294"
import script from "./FormFieldsConfigModal.vue?vue&type=script&lang=js"
export * from "./FormFieldsConfigModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__